import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
// --------- HELPERS
function getElementOffset(el) {
  var top = 0;
  var left = 0;
  var element = el;
  // Loop through the DOM tree
  // and add it's parent's offset to get page offset
  do {
    top += element.offsetTop || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent;
  } while (element);
  return {
    top: top,
    left: left
  };
}
// --------- SCROLL INTERFACES
// ScrollDomElement and ScrollWindow have identical interfaces
var ScrollDomElement = /*#__PURE__*/function () {
  function ScrollDomElement(element) {
    _classCallCheck(this, ScrollDomElement);
    this.element = element;
  }
  _createClass(ScrollDomElement, [{
    key: "getHorizontalScroll",
    value: function getHorizontalScroll() {
      return this.element.scrollLeft;
    }
  }, {
    key: "getVerticalScroll",
    value: function getVerticalScroll() {
      return this.element.scrollTop;
    }
  }, {
    key: "getMaxHorizontalScroll",
    value: function getMaxHorizontalScroll() {
      return this.element.scrollWidth - this.element.clientWidth;
    }
  }, {
    key: "getMaxVerticalScroll",
    value: function getMaxVerticalScroll() {
      return this.element.scrollHeight - this.element.clientHeight;
    }
  }, {
    key: "getHorizontalElementScrollOffset",
    value: function getHorizontalElementScrollOffset(elementToScrollTo, elementToScroll) {
      return getElementOffset(elementToScrollTo).left - getElementOffset(elementToScroll).left;
    }
  }, {
    key: "getVerticalElementScrollOffset",
    value: function getVerticalElementScrollOffset(elementToScrollTo, elementToScroll) {
      return getElementOffset(elementToScrollTo).top - getElementOffset(elementToScroll).top;
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(x, y) {
      this.element.scrollLeft = x;
      this.element.scrollTop = y;
    }
  }]);
  return ScrollDomElement;
}();
var ScrollWindow = /*#__PURE__*/function () {
  function ScrollWindow() {
    _classCallCheck(this, ScrollWindow);
    this.element = window;
  }
  _createClass(ScrollWindow, [{
    key: "getHorizontalScroll",
    value: function getHorizontalScroll() {
      return window.scrollX || document.documentElement.scrollLeft;
    }
  }, {
    key: "getVerticalScroll",
    value: function getVerticalScroll() {
      return window.scrollY || document.documentElement.scrollTop;
    }
  }, {
    key: "getMaxHorizontalScroll",
    value: function getMaxHorizontalScroll() {
      return Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.body.clientWidth, document.documentElement.clientWidth) - window.innerWidth;
    }
  }, {
    key: "getMaxVerticalScroll",
    value: function getMaxVerticalScroll() {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight) - window.innerHeight;
    }
  }, {
    key: "getHorizontalElementScrollOffset",
    value: function getHorizontalElementScrollOffset(elementToScrollTo) {
      var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
      return scrollLeft + elementToScrollTo.getBoundingClientRect().left;
    }
  }, {
    key: "getVerticalElementScrollOffset",
    value: function getVerticalElementScrollOffset(elementToScrollTo) {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      return scrollTop + elementToScrollTo.getBoundingClientRect().top;
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(x, y) {
      window.scrollTo(x, y);
    }
  }]);
  return ScrollWindow;
}();
var activeAnimations = {
  elements: [],
  cancelMethods: [],
  add: function add(element, cancelAnimation) {
    activeAnimations.elements.push(element);
    activeAnimations.cancelMethods.push(cancelAnimation);
  },
  remove: function remove(element, shouldStop) {
    var index = activeAnimations.elements.indexOf(element);
    if (index > -1) {
      // Stop animation
      if (shouldStop) {
        activeAnimations.cancelMethods[index]();
      }
      // Remove it
      activeAnimations.elements.splice(index, 1);
      activeAnimations.cancelMethods.splice(index, 1);
    }
  }
};
// --------- CHECK IF CODE IS RUNNING IN A BROWSER
var WINDOW_EXISTS = typeof window !== 'undefined';
// --------- ANIMATE SCROLL TO
var defaultOptions = {
  cancelOnUserAction: true,
  easing: function easing(t) {
    return --t * t * t + 1;
  },
  elementToScroll: WINDOW_EXISTS ? window : null,
  horizontalOffset: 0,
  maxDuration: 3000,
  minDuration: 250,
  speed: 500,
  verticalOffset: 0
};
function animateScrollTo(numberOrCoordsOrElement) {
  var userOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var x, y, scrollToElement, options, isWindow, isElement, scrollBehaviorElement, scrollBehavior, elementToScroll, maxHorizontalScroll, initialHorizontalScroll, horizontalDistanceToScroll, maxVerticalScroll, initialVerticalScroll, verticalDistanceToScroll, horizontalDuration, verticalDuration, duration;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (WINDOW_EXISTS) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", new Promise(function (resolve) {
              resolve(false); // Returning false on server
            }));
          case 4:
            if (window.Promise) {
              _context.next = 6;
              break;
            }
            throw "Browser doesn't support Promises, and animated-scroll-to depends on it, please provide a polyfill.";
          case 6:
            options = Object.assign(Object.assign({}, defaultOptions), userOptions);
            isWindow = options.elementToScroll === window;
            isElement = !!options.elementToScroll.nodeName;
            if (!(!isWindow && !isElement)) {
              _context.next = 11;
              break;
            }
            throw 'Element to scroll needs to be either window or DOM element.';
          case 11:
            // Check for "scroll-behavior: smooth" as it can break the animation
            // https://github.com/Stanko/animated-scroll-to/issues/55
            scrollBehaviorElement = isWindow ? document.documentElement : options.elementToScroll;
            scrollBehavior = getComputedStyle(scrollBehaviorElement).getPropertyValue('scroll-behavior');
            if (scrollBehavior === 'smooth') {
              console.warn("".concat(scrollBehaviorElement.tagName, " has \"scroll-behavior: smooth\" which can mess up with animated-scroll-to's animations"));
            }
            // Select the correct scrolling interface
            elementToScroll = isWindow ? new ScrollWindow() : new ScrollDomElement(options.elementToScroll);
            if (!(numberOrCoordsOrElement instanceof Element)) {
              _context.next = 23;
              break;
            }
            scrollToElement = numberOrCoordsOrElement;
            // If "elementToScroll" is not a parent of "scrollToElement"
            if (!(isElement && (!options.elementToScroll.contains(scrollToElement) || options.elementToScroll.isSameNode(scrollToElement)))) {
              _context.next = 19;
              break;
            }
            throw 'options.elementToScroll has to be a parent of scrollToElement';
          case 19:
            x = elementToScroll.getHorizontalElementScrollOffset(scrollToElement, options.elementToScroll);
            y = elementToScroll.getVerticalElementScrollOffset(scrollToElement, options.elementToScroll);
            _context.next = 34;
            break;
          case 23:
            if (!(typeof numberOrCoordsOrElement === 'number')) {
              _context.next = 28;
              break;
            }
            x = elementToScroll.getHorizontalScroll();
            y = numberOrCoordsOrElement;
            _context.next = 34;
            break;
          case 28:
            if (!(Array.isArray(numberOrCoordsOrElement) && numberOrCoordsOrElement.length === 2)) {
              _context.next = 33;
              break;
            }
            x = numberOrCoordsOrElement[0] === null ? elementToScroll.getHorizontalScroll() : numberOrCoordsOrElement[0];
            y = numberOrCoordsOrElement[1] === null ? elementToScroll.getVerticalScroll() : numberOrCoordsOrElement[1];
            _context.next = 34;
            break;
          case 33:
            throw 'Wrong function signature. Check documentation.\n' + 'Available method signatures are:\n' + '  animateScrollTo(y:number, options)\n' + '  animateScrollTo([x:number | null, y:number | null], options)\n' + '  animateScrollTo(scrollToElement:Element, options)';
          case 34:
            // Add offsets
            x += options.horizontalOffset;
            y += options.verticalOffset;
            // Horizontal scroll distance
            maxHorizontalScroll = elementToScroll.getMaxHorizontalScroll();
            initialHorizontalScroll = elementToScroll.getHorizontalScroll(); // If user specified scroll position is greater than maximum available scroll
            if (x > maxHorizontalScroll) {
              x = maxHorizontalScroll;
            }
            // Calculate distance to scroll
            horizontalDistanceToScroll = x - initialHorizontalScroll; // Vertical scroll distance distance
            maxVerticalScroll = elementToScroll.getMaxVerticalScroll();
            initialVerticalScroll = elementToScroll.getVerticalScroll(); // If user specified scroll position is greater than maximum available scroll
            if (y > maxVerticalScroll) {
              y = maxVerticalScroll;
            }
            // Calculate distance to scroll
            verticalDistanceToScroll = y - initialVerticalScroll; // Calculate duration of the scroll
            horizontalDuration = Math.abs(Math.round(horizontalDistanceToScroll / 1000 * options.speed));
            verticalDuration = Math.abs(Math.round(verticalDistanceToScroll / 1000 * options.speed));
            duration = horizontalDuration > verticalDuration ? horizontalDuration : verticalDuration; // Set minimum and maximum duration
            if (duration < options.minDuration) {
              duration = options.minDuration;
            } else if (duration > options.maxDuration) {
              duration = options.maxDuration;
            }
            // @ts-ignore
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              // Scroll is already in place, nothing to do
              if (horizontalDistanceToScroll === 0 && verticalDistanceToScroll === 0) {
                // Resolve promise with a boolean hasScrolledToPosition set to true
                resolve(true);
              }
              // Cancel existing animation if it is already running on the same element
              activeAnimations.remove(elementToScroll.element, true);
              // To cancel animation we have to store request animation frame ID
              var requestID;
              // Cancel animation handler
              var cancelAnimation = function cancelAnimation() {
                removeListeners();
                cancelAnimationFrame(requestID);
                // Resolve promise with a boolean hasScrolledToPosition set to false
                resolve(false);
              };
              // Registering animation so it can be canceled if function
              // gets called again on the same element
              activeAnimations.add(elementToScroll.element, cancelAnimation);
              // Prevent user actions handler
              var preventDefaultHandler = function preventDefaultHandler(e) {
                return e.preventDefault();
              };
              var handler = options.cancelOnUserAction ? cancelAnimation : preventDefaultHandler;
              // If animation is not cancelable by the user, we can't use passive events
              var eventOptions = options.cancelOnUserAction ? {
                passive: true
              } : {
                passive: false
              };
              var events = ['wheel', 'touchstart', 'keydown', 'mousedown'];
              // Function to remove listeners after animation is finished
              var removeListeners = function removeListeners() {
                events.forEach(function (eventName) {
                  elementToScroll.element.removeEventListener(eventName, handler, eventOptions);
                });
              };
              // Add listeners
              events.forEach(function (eventName) {
                elementToScroll.element.addEventListener(eventName, handler, eventOptions);
              });
              // Animation
              var startingTime = Date.now();
              var step = function step() {
                var timeDiff = Date.now() - startingTime;
                var t = timeDiff / duration;
                var horizontalScrollPosition = Math.round(initialHorizontalScroll + horizontalDistanceToScroll * options.easing(t));
                var verticalScrollPosition = Math.round(initialVerticalScroll + verticalDistanceToScroll * options.easing(t));
                if (timeDiff < duration && (horizontalScrollPosition !== x || verticalScrollPosition !== y)) {
                  // If scroll didn't reach desired position or time is not elapsed
                  // Scroll to a new position
                  elementToScroll.scrollTo(horizontalScrollPosition, verticalScrollPosition);
                  // And request a new step
                  requestID = requestAnimationFrame(step);
                } else {
                  // If the time elapsed or we reached the desired offset
                  // Set scroll to the desired offset (when rounding made it to be off a pixel or two)
                  // Clear animation frame to be sure
                  elementToScroll.scrollTo(x, y);
                  cancelAnimationFrame(requestID);
                  // Remove listeners
                  removeListeners();
                  // Remove animation from the active animations coordinator
                  activeAnimations.remove(elementToScroll.element, false);
                  // Resolve promise with a boolean hasScrolledToPosition set to true
                  resolve(true);
                }
              };
              // Start animating scroll
              requestID = requestAnimationFrame(step);
            }));
          case 49:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
export default animateScrollTo;